import React from "react";
import Header from "../../components/VibrantSolComponents/Header";
import Footer from "../../components/VibrantSolComponents/Footer";

// You can replace these with your own images or imports if you have them
const profileImages = [
  "https://randomuser.me/api/portraits/men/32.jpg",
  "https://randomuser.me/api/portraits/women/44.jpg",
  "https://randomuser.me/api/portraits/men/45.jpg",
  "https://randomuser.me/api/portraits/women/68.jpg",
];

const doctors = [
  {
    name: "Dr. Rajiv Sharma",
    designation: "Dermatologist",
    expertise: "Hair Restoration, Skin Disorders, Laser Therapy",
  },
  {
    name: "Dr. Meera Chopra",
    designation: "Trichologist",
    expertise: "Hair Regrowth, PRP Therapy, Hair Transplantation",
  },
  {
    name: "Dr. Vikram Patel",
    designation: "Endocrinologist",
    expertise: "Hormonal Imbalance, Metabolic Disorders, Diabetes Care",
  },
  {
    name: "Dr. Priya Singh",
    designation: "Nutritionist",
    expertise: "Weight Management, Dietary Counseling, Wellness Coaching",
  },
  {
    name: "Dr. Anil Gupta",
    designation: "Psychiatrist",
    expertise: "Mental Health, Stress Management, Cognitive Therapy",
  },
  {
    name: "Dr. Shweta Verma",
    designation: "Sexologist",
    expertise: "Sexual Health, Male & Female Wellness, Relationship Counseling",
  },
];

// Helper for random image assignment
function getRandomImage(index) {
  return profileImages[index % profileImages.length];
}

function OurExperts() {
  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2">
            <li>
              <span className="text-gray-400 font-medium">Home</span>
            </li>
            <li>
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Our Experts</span>
            </li>
          </ol>
        </nav>
        <div className="bg-white text-gray-800 max-w-7xl mx-auto px-4 py-12">
          <h1 className="text-3xl md:text-4xl text-center mb-6 secdory-font">
            Our Experts
          </h1>
          <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {doctors.map((doc, idx) => (
              <div
                key={idx}
                className="bg-white shadow border border-gray-200 rounded-lg p-6 flex flex-col items-center"
              >
                <img
                  src={getRandomImage(idx)}
                  className="w-28 h-28 rounded-full mb-4 object-cover border-4 border-blue-100"
                  alt={doc.name}
                />
                <h2 className="text-lg font-semibold text-gray-800">
                  {doc.name}
                </h2>
                <div className="text-blue-600 font-medium">
                  {doc.designation}
                </div>
                <div className="text-gray-600 text-center mt-2 text-sm">
                  <span className="font-semibold">Expertise:</span>
                  <br />
                  {doc.expertise}
                </div>
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default OurExperts;
